import { render, staticRenderFns } from "./sourceCode.vue?vue&type=template&id=797e1fc6&scoped=true"
import script from "./sourceCode.vue?vue&type=script&lang=ts"
export * from "./sourceCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e1fc6",
  null
  
)

export default component.exports